import { Component, OnInit } from '@angular/core';
import {IconBaseComponent} from '../base/icon-base.component';

@Component({
  selector: 'app-icon-warn',
  templateUrl: './icon-warn.component.html',
  styleUrls: ['./icon-warn.component.scss']
})
export class IconWarnComponent extends IconBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
